import { render, staticRenderFns } from "./listRecord.vue?vue&type=template&id=72c509fc&scoped=true"
import script from "./listRecord.vue?vue&type=script&lang=js"
export * from "./listRecord.vue?vue&type=script&lang=js"
import style0 from "./listRecord.vue?vue&type=style&index=0&id=72c509fc&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c509fc",
  null
  
)

export default component.exports